/**
 * Layout.tsx
 *
 * Layout component for the main application structure with header and routed content.
 */

import { Outlet } from 'react-router'
import ResponsiveAppBar from '../Header'
import { ROUTES } from '../route/RouteConstant'

export const Layout = () => {
  // Check if current route is Customer360
  const isCustomer360 = window.location.pathname === ROUTES.CUSTOMER_360;
  const backgroundColor = isCustomer360 ? "#ffffff" : "#f5f5f5";

  return (
    <div style={{ 
      display: "flex", 
      flexDirection: "column", 
      height: "100vh",
      backgroundColor: backgroundColor 
    }}>
      <div style={{ height: "8vh" }}>
        <ResponsiveAppBar/>
      </div>
      <div style={{ 
        flex: 1, 
        overflow: "auto",
        backgroundColor: backgroundColor 
      }}>
        <Outlet/>
      </div>
    </div>
  )
}



